import React, { useState } from "react";
import { useWatchState } from "@/store";
import { checkResult } from "@/common";
import { BaseService, RemindService } from "@/service";
import moment from "moment";
import { Modal, Button, Form, Input, message } from "antd";

const { TextArea } = Input;
const TABLE_NAME = "cheese";

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 3 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 21 },
    },
};

const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 16,
            offset: 8,
        },
    },
};

const App = Form.create({ name: 'register' })((props) => {

    const { getFieldDecorator } = props.form;

    const [loading, setLoading] = useState(false);
    const [[{ title, show, hide, width = 800, vo = {}, state, contrast, callback }]] = useWatchState(["modal.cheese"])

    const add = async vo => {
        const add_time = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
        setLoading(true);
        const res = await BaseService.add({ table: TABLE_NAME, data: { ...vo, add_time } });
        setLoading(false);
        if (!checkResult(res.data)) return;

        const { id } = res.data.result;
        const remindRes = await RemindService.add({ cheese_id: id, ai: 1, remind_start_time: add_time, ai_stage: 1 });
        if (!checkResult(remindRes)) return;

        message.success("添加成功！");
        hide();
        if (callback) callback();
    }

    const put = async values => {
        const update_time = moment(new Date()).format('YYYY-MM-DD hh:mm:ss')
        let vo = contrast(values, ["id"]);
        setLoading(true);
        const res = await BaseService.put({ table: TABLE_NAME, data: { ...vo, update_time }, where: { id: vo.id } });
        setLoading(false);
        if (!checkResult(res)) return;
        message.success("修改成功！");
        hide();
        if (callback) callback();
    }

    const funs = { add, put }

    const handleSubmit = (e) => {
        e.preventDefault();
        props.form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                console.log('Received values of form: ', values);
                funs[state](values);
            }
        });
    };

    return (
        <Modal
            title={title}
            visible={show}
            width={width}
            maskClosable={false}
            onCancel={hide}
            footer={false}
        >
            <Form {...formItemLayout} onSubmit={handleSubmit}>
                <Form.Item label="标题">
                    {getFieldDecorator('title', {
                        initialValue: vo.title,
                        rules: [
                            {
                                required: true,
                                message: '请输入标题！',
                            },
                        ],
                    })(<Input placeholder="请输入标题" />)}
                </Form.Item>
                <Form.Item label="内容">
                    {getFieldDecorator('profile', {
                        initialValue: vo.profile,
                        rules: [
                            {
                                required: true,
                                message: '请输入内容！',
                            },
                        ],
                    })(<TextArea placeholder="请输入内容" />)}
                </Form.Item>
                <Form.Item {...tailFormItemLayout}>
                    <Button type="primary" htmlType="submit" loading={loading}>
                        保存
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
})

export default App;